// import LegacyGeometryParser from './legacy';
// export default LegacyGeometryParser;

import GeometryParser from './src';
export default GeometryParser;



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-geometry/index.js